import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import Button from './UI/Button';
import Card from './UI/Card';

const FeedbackScreen = ({ onSubmit, onSkip }) => {
  const { t } = useTranslation();
  const [overallRating, setOverallRating] = useState(0);
  const [specificRatings, setSpecificRatings] = useState({
    easeOfUse: 0,
    educational: 0,
    engaging: 0,
    limitAwareness: 0,
    realistic: 0,
  });

  const handleSpecificRating = (category, value) => {
    setSpecificRatings(prev => ({
      ...prev,
      [category]: value
    }));
  };

  const handleSubmit = () => {
    onSubmit({
      overallRating,
      specificRatings,
    });
  };

  const RatingStars = ({ value, onChange, size = 'text-3xl' }) => (
    <div className="flex gap-2">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          onClick={() => onChange(star)}
          className={`${size} transition-colors ${
            star <= value ? 'text-yellow-400' : 'text-gray-300'
          }`}
          aria-label={`Rate ${star}`}
        >
          ★
        </button>
      ))}
    </div>
  );

  return (
    <Card className="p-3 sm:p-6">
      <div className="flex flex-col items-center">
        <h2 className="text-2xl font-bold text-center mb-2 text-heading text-hc-black">
          {t('feedback.title', 'Rate experience')}
        </h2>
        <p className="text-center text-base text-gray-700 mb-6">
          {t('feedback.subtitle', 'Please help us improve our understandings')}
        </p>
        <div className="w-full bg-gray-50 rounded-xl p-4 sm:p-8 flex flex-col items-center">
          <h3 className="text-xl font-semibold text-center mb-4">
            {t('feedback.overall', 'Overall experience')}
          </h3>
          <RatingStars value={overallRating} onChange={setOverallRating} size="text-6xl" />

          <div className="mt-8 w-full max-w-xs mx-auto space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-900">{t('feedback.ease_of_use', 'Ease of use')}</span>
              <RatingStars value={specificRatings.easeOfUse} onChange={(value) => handleSpecificRating('easeOfUse', value)} size="text-2xl" />
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-900">{t('feedback.educational', 'Educational value')}</span>
              <RatingStars value={specificRatings.educational} onChange={(value) => handleSpecificRating('educational', value)} size="text-2xl" />
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-900">{t('feedback.realistic', 'Realism')}</span>
              <RatingStars value={specificRatings.realistic} onChange={(value) => handleSpecificRating('realistic', value)} size="text-2xl" />
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-900">{t('feedback.engaging', 'Engagement')}</span>
              <RatingStars value={specificRatings.engaging} onChange={(value) => handleSpecificRating('engaging', value)} size="text-2xl" />
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 w-full mt-8">
          <Button
            fullWidth
            onClick={onSkip}
            variant="secondary"
          >
            {t('feedback.skip', 'Skip')}
          </Button>
          <Button
            fullWidth
            onClick={handleSubmit}
            variant="primary"
            disabled={overallRating === 0}
          >
            {t('feedback.submit', 'Submit Feedback')}
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default FeedbackScreen; 